// extracted by mini-css-extract-plugin
export default {"wrap":"ActionsMenu_wrap__We1Qn","button":"ActionsMenu_button__J9gFc"};